import { useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.less';

/**
 * 单个套餐标签
 * @param {Object} label tagInfo运营后台参数统一
 */
const VersionLabel = inject('area')(
  observer((props) => {
    const {
      label = {},
      area: {
        country: { X_Language },
      },
    } = props;
    if (!label?.tagContent) return <></>;

    const style = useMemo(() => {
      // 运营后台可配置的样式
      const styleMap = {
        'backGroundColor': 'background',
        'fontColor': 'color',
      };
      const _style = {};
      Object.keys(label).forEach((key) => {
        if (styleMap[key]) {
          _style[styleMap[key]] = label[key].replace(';', '');
        }
      });
      return _style;
    }, [label]);

    return (
      <span key={label.tagContent} className={styles.VersionLabel} style={style} data-l={X_Language}>
        {label.tagContent}
      </span>
    );
  })
);

export default VersionLabel;
